import React from 'react';
import $ from 'jquery';

import { FaEnvelope, FaPhone } from 'react-icons/fa';

class Contact extends React.Component {
  removeForm = () => {
    $('.form-wrapper').fadeOut(300);
  };

  render() {
    return (
      <div className="contact-wrapper" id="contact">
        <h2 className="contact-title">Kontaktujte nás</h2>
        <hr></hr>
        <div className="grid">
          <div className="maill tablet">
            <FaEnvelope className="contact-icon mail" />
            <p className="contact-icon-desc">
              <a href="mailto:d.batka@seznam.cz">d.batka@seznam.cz</a>
            </p>
          </div>
          <div className="phonee tablet">
            <FaPhone className="contact-icon phone" />
            <p className="contact-icon-desc">
              <a href="tel:777 338 077">777 338 077</a>
            </p>
          </div>
          <div className="mailicondiv mobile">
            <FaEnvelope className="contact-icon mail" />
          </div>
          <div className="maildiv mobile">
            <p className="contact-icon-desc">
              <a href="mailto:d.batka@seznam.cz">d.batka@seznam.cz</a>
            </p>
          </div>
          <div className="phoneicondiv mobile">
            <FaPhone className="contact-icon phone" />
          </div>
          <div className="phonediv mobile">
            <p className="contact-icon-desc">
              <a href="tel:777 338 077">777 338 077</a>
            </p>
          </div>
        </div>

        <div className="form-wrapper">
          <form className="contact-form" action="contactForm.php" method="post">
            <input
              name="name"
              className="contact-form-input name"
              type="text"
              placeholder="Jméno"
            ></input>
            <input
              name="mail"
              className="contact-form-input email"
              type="email"
              placeholder="Email"
            ></input>
            <input
              name="tel"
              className="contact-form-input phone"
              type="number"
              placeholder="Telefon"
            ></input>
            <textarea
              name="message"
              rows="10"
              className="contact-form-input message"
              type="text"
              placeholder="Zpráva"
            ></textarea>
            <div>
              <button
                onClick={this.removeForm}
                type="submit"
                name="submit"
                className="contact-btn"
              >
                Odeslat
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact.js